module.exports = __webpack_public_path__ + "img/11.5b012465.png";